import React from 'react'
import { useSelector } from 'react-redux'

const PromptTab = ({ setSelectedOption1, selectedOption1 }) => {
  const { textToImagePrompts } = useSelector((state) => state.prompt)
  return (
    <div className="tweak-tab flex w-full md:w-auto md:justify-center items-center pb-2 md:pb-0 mb-1 md:mb-5 md:overflow-visible overflow-x-auto ">
      {Object.keys(textToImagePrompts || {})?.map((item, i) => {
        return (
          <div
            className={`border-none text-sm font-medium rounded-md md:rounded-none md:text-base px-3 md:py-2 py-1 md:px-12 cursor-pointer text-center  ${selectedOption1 == item && '!bg-[#EBEBEB] !font-black '}`}
            onClick={() => setSelectedOption1(item)}
            key={i}
          >
            <span className="whitespace-nowrap">{item}</span>
          </div>
        )
      })}
    </div>
  )
}

export default PromptTab
